import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
import Swiper from 'swiper';
import { Autoplay, EffectFade, FreeMode } from 'swiper/modules';
import Splide from '@splidejs/splide';
import Swup from 'swup';
import SwupJsPlugin from '@swup/js-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import anime from 'animejs/lib/anime.es.js';
import splt from 'spltjs';
import Masonry from 'masonry-layout';
import Isotope from 'isotope-layout';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/rias/ls.rias';
import Plyr from 'plyr';
import { gsap } from "gsap";

import '@splidejs/splide/css';

Swiper.use([Autoplay, EffectFade, FreeMode]);

const body = document.body;
const select = e => document.querySelector(e);
const selectAll = e => document.querySelectorAll(e);

const swup = new Swup({
    plugins: [
        new SwupPreloadPlugin(),
        new SwupJsPlugin({ 
            animations: [
                {
                    from: '/', // matches any route
                    to: '(.*)', // matches any route
                    out: async () => {
                        let height = -window.innerHeight + 'px';
                        let tl = gsap.timeline();
                        tl.to('#ticker-screen', { y: height, duration: 0.75, ease: "power1.in", })
                        .to('#swup', { opacity: 0, duration: 0.5}, ">");
                        await tl.then(() => {
                            return;
                        });
                    },
                    in: async () => {
                        let tl = gsap.timeline();
                        tl.fromTo('#swup', { opacity: 0 }, { opacity: 1, duration: 0.5, ease: "power1.inOut"});
                        await tl.then(() => {
                            return;
                        });
                    }
                },
                {
                    from: '(.*)', // matches any route
                    to: '(.*)', // matches any route
                    out: async () => {
                        let tl = gsap.timeline();
                        tl.to('#swup', { opacity: 0, duration: 0.5, ease: "power1.inOut" });
                        await tl.then(() => {
                            return;
                        });
                    },
                    in: async () => {
                        let tl = gsap.timeline();
                        tl.fromTo('#swup', { opacity: 0 }, { opacity: 1, duration: 0.5, ease: "power1.inOut"});
                        await tl.then(() => {
                            return;
                        });
                    }
                }
            ] 
        })
    ]
    
});

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('load', () => {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});

// We listen to the resize event
window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.rias = {
    prefix: '/w_{width}/',
    absUrl: true
};
window.lazySizesConfig.expand = window.innerHeight;
window.lazySizesConfig.expFactor = 5;
window.lazySizesConfig.loadMode = 3;

Alpine.data('pageSettings', () => ({
    isPageReady: false,
    isNavOpen: false,
    pageChanging: false,
    gridView: true,
    listView: false,
}));

Alpine.store('isProjectPanelOpen', false);

Alpine.data('bodyColour', () => ({
    init(){
        this.transitionDelayFix();

        if (sessionStorage.getItem('darkMode') == 'false') {
            Alpine.store('darkMode', false);
            document.querySelector('meta[name="theme-color"]').setAttribute("content", '#ffffff');
        } else {
            Alpine.store('darkMode', true);
            document.querySelector('meta[name="theme-color"]').setAttribute("content", '#000000');
        }
    },
    setDefaultBackground(){

        this.transitionDelayFix();

        if (Alpine.store('darkMode') == false) {
            document.querySelector('meta[name="theme-color"]').setAttribute("content", '#ffffff');
            sessionStorage.setItem('darkMode', false);
        } else {
            sessionStorage.setItem('darkMode', true);
            document.querySelector('meta[name="theme-color"]').setAttribute("content", '#000000');
        }
    },

    transitionDelayFix() {
        const transitionElements = document.querySelectorAll('.dark-mode-transition');

        transitionElements.forEach((element) => {
            element.classList.add('dark-mode-transition-occuring');
            setTimeout(() => {
                element.classList.remove('dark-mode-transition-occuring');
            }, 200);
        });

    }
}));

function logoReveal(element) {
    const logos = element.querySelectorAll('.js-logo');

    window.setTimeout(()=>{
        logos.forEach((logo) => {
            logo.classList.remove('opacity-0');
        });
    }, 750);

}

Alpine.data('projectVideo', () => ({
    init(){
        const player = new Plyr(this.$el, {
            controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen' ]
        });
    }
}));

Alpine.data('ticker', () => ({
    init(){
        gsap.to(this.$el.querySelectorAll('svg'), {
            duration: 10,
            repeat: -1,
            ease: "none",
            x: "-100%",
        });
    }
}));

Alpine.data('studioSlider', () => ({
    initSlider(element) {
        setTimeout(() => {
            const swiper = new Swiper(element, {
                modules: [FreeMode],
                loop: false,
                freeMode: true,
                slidesPerView: 'auto',
                spaceBetween: 10,
                // slidesOffsetAfter: -(window.innerWidth * 2.5),
                // width: window.innerWidth
            });
        },200)
    }
}));

Alpine.data('parallaxColumns', (element) => ({
    init(){
        const paraCol = element.querySelector('.js-para-col')
        const main = document.querySelector('main');

        main.addEventListener('scroll', () => {
            let mainScroll = main.scrollTop;
            let offset = 0;

            if(window.innerWidth < 1024) {
                offset = Math.round(mainScroll * 0.005);
            } else {
                offset = Math.round(mainScroll * 0.075);
            }

            paraCol.style.transform ="translateY(-" + offset + "px)";
        });
    }
}));

Alpine.data('imageSlider', () => ({
    currentSlider: undefined,
    screenSize: undefined,

    sliderListener(fadeSpeed, timePerSlide, timeBeforeTransition) {

        if(window.innerWidth < 768) {
            this.screenSize = 'mobile';
            this.newSlider(this.$refs.mobileSlider, fadeSpeed, timePerSlide, timeBeforeTransition);
        } else {
            this.screenSize = 'desktop';
            this.newSlider(this.$refs.desktopSlider, fadeSpeed, timePerSlide, timeBeforeTransition);
        }


        window.addEventListener('resize', () => {
            if(window.innerWidth < 768) {
                if(this.screenSize !== 'mobile') {
                    this.killSlider();
                    this.screenSize = 'mobile';
                    this.newSlider(this.$refs.mobileSlider, fadeSpeed, timePerSlide, timeBeforeTransition);
                }
            } else {
                if(this.screenSize !== 'desktop') {
                    this.killSlider();
                    this.screenSize = 'desktop';
                    this.newSlider(this.$refs.desktopSlider, fadeSpeed, timePerSlide, timeBeforeTransition);
                }
            }
        });
    },

    newSlider(element, fadeSpeed, timePerSlide, timeBeforeTransition) {
        if(!fadeSpeed) {
            fadeSpeed = 300;
        }

        if (!timePerSlide) {
            timePerSlide = 2000;
        }

        this.currentSlider = new Splide(element, {
            type : 'fade',
            autoplay: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            interval: timePerSlide,
            isNavigation: false,
            pagination: false,
            arrows: false,
            speed: fadeSpeed,
        });

        this.currentSlider.on('ready', () => {
            let activeSlideElement = this.currentSlider.Components.Elements.slides[0];

            if(activeSlideElement.querySelector('video')) {
                activeSlideElement.querySelector('video').play();
            }

            if(timeBeforeTransition) {
                setTimeout(() => {
                    this.triggerTransition();
                }, timeBeforeTransition);
            }
        });

        this.currentSlider.on('moved', (newIndex, prevIndex) => {
            let activeSlideElement = this.currentSlider.Components.Elements.slides[newIndex];
            let prevSlideElement = this.currentSlider.Components.Elements.slides[prevIndex];

            if(activeSlideElement.querySelector('video')) {
                activeSlideElement.querySelector('video').play();
            }

            if(prevSlideElement.querySelector('video')) {
                prevSlideElement.querySelector('video').pause();
            }

            if(!timeBeforeTransition) {
                if(newIndex === (this.currentSlider.length - 1)) {
                    this.triggerTransition();
                }
            }
        });

        this.currentSlider.mount();
    },

    killSlider() {
        if(this.currentSlider) {
            this.currentSlider.destroy();
        }
    },

    triggerTransition() {
        document.querySelector('#js-transition').click();
    }

}));

Alpine.data('projectsFilter', () => ({
    layoutType: 'grid',
    filterSlug: 'all',
    grid: null,

    initGrid(element) {
        window.addEventListener('load', () => {
            window.setTimeout(() => {
                this.grid = new Isotope(element, {
                    itemSelector: '.grid-item',
                    percentPosition: true,
                    masonry: {
                        percentPosition: true,
                        columnWidth: '.m-grid-sizer',
                        gutter: 10
                    }
                });

                element.classList.remove('opacity-0');
            },1500)
        });
        window.addEventListener('resize', () => {
            window.setTimeout(() => {
                this.grid = new Isotope(element, {
                    itemSelector: '.grid-item',
                    percentPosition: true,
                    masonry: {
                        percentPosition: true,
                        columnWidth: '.m-grid-sizer',
                        gutter: 10
                    }
                });

                element.classList.remove('opacity-0');
            }, 100)
        });
    },
    updateFilter(slug) {
        this.filterSlug = slug

        const iso = Isotope.data(document.querySelector('.masonry-grid'));

        if(slug == 'all') {
            iso.arrange({
                filter: '*'
            });
        } else {
            iso.arrange({
                filter: '.' + slug
            });
        }

        iso.layout();

        const listItems = document.querySelectorAll('.js-filter-list-item');

        listItems.forEach((item) => {
            const cats = item.getAttribute('data-categories');

            if(slug == 'all') {
                item.classList.remove('hidden');
            } else {
                if(!cats.includes(slug)) {
                    item.classList.add('hidden');
                } else {
                    item.classList.remove('hidden');
                }
            }
        });
    }
}));

Alpine.data('studiesFilter', () => ({
    layoutType: 'grid',
    filterSlug: 'all',
    grid: null,
    showMobileInfoPanel: false,
    panelTitle: '',
    panelImage: '',
    panelVideoUrl: '',
    panelDesc: '',

    initGrid(element) {
        window.addEventListener('load', () => {
            window.setTimeout(() => {
                this.grid = new Isotope(element, {
                    itemSelector: '.a-grid-item',
                    percentPosition: true,
                    masonry: {
                        columnWidth: '.a-grid-sizer',
                        gutter: 10
                    }
                });
            }, 100)
        });
        window.addEventListener('resize', () => {
            window.setTimeout(() => {
                this.grid = new Isotope(element, {
                    itemSelector: '.a-grid-item',
                    percentPosition: true,
                    masonry: {
                        columnWidth: '.a-grid-sizer',
                        gutter: 10
                    }
                });
            }, 100)
        });
    },
    itemResized() {
        window.setTimeout(() => {
            this.grid.layout();
        }, 10);
    },
    updateFilter(slug) {
        this.filterSlug = slug

        const iso = Isotope.data(document.querySelector('.masonry-grid'));

        if (slug == 'all') {
            iso.arrange({
                filter: '*'
            });
        } else {
            iso.arrange({
                filter: '.' + slug
            });
        }

        iso.layout();

        const listItems = document.querySelectorAll('.js-filter-list-item');

        listItems.forEach((item) => {
            const cats = item.getAttribute('data-categories');

            if (slug == 'all') {
                item.classList.remove('hidden');
            } else {
                if (!cats.includes(slug)) {
                    item.classList.add('hidden');
                } else {
                    item.classList.remove('hidden');
                }
            }
        });
    }
}));

Alpine.data('singleProjectGrid', () => ({
    initGrid(element) {
        window.addEventListener('load', () => {
            window.setTimeout(() => {
                this.grid = new Isotope(element, {
                    itemSelector: '.m-grid-item',
                    percentPosition: true,
                    masonry: {
                        columnWidth: '.m-grid-sizer',
                        gutter: 10
                    }
                });
            }, 100)
        });
        window.addEventListener('resize', () => {
            window.setTimeout(() => {
                this.grid = new Isotope(element, {
                    itemSelector: '.m-grid-item',
                    percentPosition: true,
                    masonry: {
                        columnWidth: '.m-grid-sizer',
                        gutter: 10
                    }
                });
            }, 100)
        });
    }
}));

function numberReveal() {
    splt({
        reveal: true
    });
    anime({
        targets: '.reveal',
        translateY: [60 + (window.innerWidth*.025),0],
        loop: 0,
        delay: anime.stagger(12),
        easing: 'cubicBezier(0.84,0.11,0.2,0.87)'
    });
}

swup.hooks.on('page:view', function () {
    window.setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
    },500);
});

swup.hooks.on('content:replace', function () {
    window.scrollTo(0, 0);
    window.setTimeout(() => {
        window.dispatchEvent(new Event('resize'));

        if(document.querySelectorAll('video[autoplay]')) {
            const videos = document.querySelectorAll('video[autoplay]');
            videos.forEach(video => {
                video.play().catch(error => {
                    console.warn('Autoplay failed:', error);
                });
            });
        }

        Alpine.store('isProjectPanelOpen', false);
    }, 500);
    window.setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
    }, 3000);
});



window.Anime = anime;
window.splt = splt;
window.logoReveal = logoReveal;
window.numberReveal = numberReveal;

Alpine.plugin(intersect);
Alpine.plugin(collapse);
window.Alpine = Alpine;
Alpine.start();
